import { useState } from 'react';
import { Mail, ArrowRight } from 'lucide-react';
import AppStoreButtons from './AppStoreButtons';
import AnimateIn from './AnimateIn';

function CTABackground() {
  return (
    <>
      <div className="absolute inset-0 actcheck-gradient" />
      <div className="absolute inset-0 bg-navy/30" />
      <div className="absolute top-[-10%] right-[-5%] w-[400px] h-[400px] rounded-full bg-compliance-green/10 blur-3xl" />
      <div className="absolute bottom-[-20%] left-[-10%] w-[500px] h-[500px] rounded-full bg-navy/40 blur-3xl" />
    </>
  );
}

function WaitlistForm() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email.trim()) {
      setSubmitted(true);
      setEmail('');
    }
  };

  return (
    <div id="waitlist" className="glass-card rounded-2xl p-6 sm:p-8 max-w-md mx-auto">
      <div className="flex items-center justify-center gap-2 mb-3">
        <Mail size={18} className="text-soft-teal" />
        <span className="text-white/80 font-body font-medium text-sm">Get launch updates</span>
      </div>
      {submitted ? (
        <div data-testid="waitlist-success" className="py-3">
          <p className="text-compliance-green font-body font-semibold">Thanks for signing up!</p>
          <p className="text-white/60 font-body text-sm mt-1">We'll let you know when ActCheck launches.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} data-testid="waitlist-form" className="flex gap-2">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            data-testid="waitlist-email-input"
            required
            className="flex-1 bg-white/10 border border-white/15 rounded-xl px-4 py-3 text-white placeholder:text-white/40 font-body text-sm focus:outline-none focus:border-compliance-green/50 focus:ring-1 focus:ring-compliance-green/30 transition-all"
          />
          <button
            type="submit"
            data-testid="waitlist-submit-button"
            className="bg-compliance-green hover:bg-compliance-green/90 text-white font-body font-semibold text-sm px-5 py-3 rounded-xl transition-all duration-200 flex items-center gap-1.5 hover:shadow-lg hover:shadow-compliance-green/25"
          >
            Join
            <ArrowRight size={16} />
          </button>
        </form>
      )}
    </div>
  );
}

export default function FinalCTA() {
  return (
    <section id="download" data-testid="final-cta-section" className="relative py-20 sm:py-28 overflow-hidden">
      <CTABackground />
      <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <AnimateIn>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-white mb-5">
            Ready to take control of your tenancy?
          </h2>
        </AnimateIn>
        <AnimateIn delay={100}>
          <p className="text-white/70 font-body text-lg sm:text-xl mb-10 max-w-xl mx-auto">
            Download ActCheck today and start staying organised, compliant, and protected.
          </p>
        </AnimateIn>
        <AnimateIn delay={200}>
          <div className="flex justify-center mb-10">
            <AppStoreButtons variant="glass" />
          </div>
        </AnimateIn>
        <AnimateIn delay={300}>
          <WaitlistForm />
        </AnimateIn>
      </div>
    </section>
  );
}
